import { uid } from '../../../utils/random';
import { List, Map, fromJS } from 'immutable';
import moment from 'moment';

export function request(state, { id }) {
    id = parseInt(id, 10);

    const bets = state.get('referred-betslip') || Map();
    let user = bets.get(id) || Map();

    user = user
        .set('state', 'IN_PROGRESS')
        .set('errors', void 0);

    return state.set('referred-betslip', bets.set(id, user));
}

export function error(state, { id, errors }) {
    id = parseInt(id, 10);

    const bets = state.get('referred-betslip') || Map();
    let user = bets.get(id) || Map();

    user = user
        .set('list', List())
        .set('state', 'ERROR')
        .set('errors', fromJS(errors));

    return state.set('referred-betslip', bets.set(id, user));
}

export function finish(state, { id, results, expiresAt, assignee, status, when }) {

    // window.$appState.reduxAction.refreshPossibleBet(id);

    id = parseInt(id, 10);

    let userLegs = Map();
    let userBets = List();
    let singles = Map();

    expiresAt = expiresAt ? moment().add(moment(expiresAt).diff(moment(when))) : null;

    if (moment(expiresAt).diff(moment(), 'seconds') <= 0 && expiresAt) {
        return state;
    }

    results.forEach(result => {
        const betUid = uid();

        result = {
            ...result,
            uid: betUid,
            referredStatus: status,
            isReferred: true,
            freebet: result.freebet || (result.freebetCredits || []).length > 0,
            isExpired: expiresAt ? moment(expiresAt).diff(moment(), 'seconds') <= 0 : false,
            stakePerLine: result.stakePerLine / 100,
            legs: [].concat(result.legs)
        };

        result.legs.forEach((leg, i) => {
            const legUid = (result.type === 'SGL' || result.type === 'BB') ? betUid : uid();
            let legIsUsed = false;

            if (result.type !== 'SGL' && result.type !== 'BB') {
                for (const r of results) {
                    if (r.type === 'SGL' && fromJS(r.legs[0]).equals(fromJS(leg))) {
                        legIsUsed = true;
                        break;
                    }
                }
            }
            const legSelectionId = leg.selectionId ?? (leg.legReference && leg.legReference.geniusMarketId);

            leg = {
                ...leg,
                uid: legUid,
                price: leg.price ? leg.price.f : leg.price,
                freeBets: result.freeBets
            };

            userLegs = userLegs.set(legUid, fromJS(leg));
            state = state.setIn([ 'legs', id ], userLegs);

            if (result.type !== 'SGL' && result.type !== 'BB' && !legIsUsed) {
                singles = singles.set(legSelectionId, fromJS({
                    uid: legUid,
                    type: 'SGL',
                    name: 'Single',
                    numLines: 1,
                    stakePerLine: 0,
                    legs: [
                        legUid
                    ]
                }));
            }

            result.legs[i] = legUid;
        });

        userBets = userBets.push(fromJS(result));
    });

    userBets = userBets.concat(singles);
    return state
        .setIn([ 'bets', id ], userBets)
        .setIn([ 'referred-betslip', id ], Map({
            state: 'FINISHED',
            assignee: fromJS(assignee),
            errors: void 0
        }));
}

export function clear(state, { id }) {
    return state
            .setIn([ 'referred-betslip', id ], Map())
            .setIn([ 'combinations', id ], List())
            .setIn([ 'bets', id ], List())
            .setIn([ 'multiples', id ], Map())
            .setIn([ 'legs', id ], Map());
}
